const contactFields = [
    {
        columns: [
            {
                type: "text",
                id: "name",
                name: "name",
                label: "Ime / korisničko ime",
                labelAlignLeft: true,
                labelWidth: 200,
                validationType: "string",
                validations: [
                    {
                        type: "required",
                    },
                ],
                value: "demo",
            },
            {
                type: "email",
                id: "email",
                name: "email",
                label: "Kontakt e-mail adresa",
                labelAlignLeft: true,
                labelWidth: 200,
                validationType: "string",
                validations: [
                    {
                        type: "required",
                    },
                    {
                        type: "email",
                    },
                ],
                value: "email",
            },
            {
                type: "text",
                id: "country",
                name: "country",
                label: "Grad i država",
                labelAlignLeft: true,
                labelWidth: 200,
                validationType: "string",
                validations: [
                    {
                        type: "required",
                    },
                ],
            },
            {
                type: "select",
                id: "report_type",
                name: "report_type",
                label: "Tip prijave",
                labelAlignLeft: true,
                labelWidth: 200,
                placeholder: "Odaberi tip prijave",
                options: [
                    {
                        label: "Pohvala",
                        value: "Pohvala",
                    },
                    {
                        label: "Kritika",
                        value: "Kritika",
                    },
                    {
                        label: "Prijedlog daljnjeg razvoja",
                        value: "Prijedlog daljnjeg razvoja",
                    },
                    {
                        label: "Tehničke poteškoće",
                        value: "Tehničke poteškoće",
                    },
                    {
                        label: "Natječaji",
                        value: "Natječaji",
                    },
                    {
                        label: "Oglašavanje",
                        value: "Oglašavanje",
                    },
                    {
                        label: "Osobni podaci/GDPR",
                        value: "Osobni podaci/GDPR",
                    },
                    {
                        label: "Ostalo",
                        value: "Ostalo",
                    },
                    {
                        label: "Prijava neprimjerenog sadržaja",
                        value: "Prijava neprimjerenog sadržaja",
                    },
                ],
                validationType: "string",
                validations: [
                    {
                        type: "required",
                    },
                ],
            },
            {
                type: "textarea",
                id: "message",
                name: "message",
                label: "Poruka",
                labelAlignLeft: true,
                labelWidth: 200,
                validationType: "string",
                validations: [
                    {
                        type: "required",
                    },
                ],
            },
            {
                type: "hidden",
                id: "contentUrl",
                name: "contentUrl",
            },
        ],
    },
];

export default contactFields;
